import styled from 'styled-components';

const Layer = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;

// The two right-hand corner brackets are all that is left of the reticle:
// the crosshair, ticks and centre box went (they suggested an aiming
// reference the feed does not have), and the left-hand brackets before them.
// Steel, not yellow -- the Identity plate carries this panel's one accent.
const Bracket = styled.div`
  position: absolute;
  width: 26px;
  height: 26px;
  border-color: rgba(219, 228, 236, 0.4);
  border-style: solid;
  border-width: 0;
`;

const TopRight = styled(Bracket)`
  top: 14px;
  right: 14px;
  border-top-width: 1px;
  border-right-width: 1px;
`;
const BottomRight = styled(Bracket)`
  bottom: 14px;
  right: 14px;
  border-bottom-width: 1px;
  border-right-width: 1px;
`;

export default function Reticle() {
  return (
    <Layer>
      <TopRight />
      <BottomRight />
    </Layer>
  );
}
